import { OVERVIEW_DASHBOARD_FILTER_DEMO_DATA } from 'src/const';
import { PriceTiers } from 'src/interfaces/idashboard';
import { FilterVal } from 'src/interfaces/iproptypes';
import {
  GET_GRAPH_LOAD_END,
  GET_GRAPH_LOAD_START,
  GET_SEARCH_LOAD_END,
  GET_SEARCH_LOAD_START,
  GET_MARKERS_LOAD_START,
  GET_MARKERS_LOAD_END,
  GET_OTA_MARKERS_LOAD_START,
  GET_OTA_MARKERS_LOAD_END,
  GET_MULTIPLE_MARKERS_CALL_LOAD_START,
  GET_MULTIPLE_MARKERS_CALL_LOAD_END,
  GET_MULTIPLE_OTA_MARKERS_CALL_LOAD_START,
  GET_MULTIPLE_OTA_MARKERS_CALL_LOAD_END,
  GET_TAILORED_REGION_MARKERS_SUCCESS,
  GET_REVIEW_STREAM_LOAD_START,
  GET_REVIEW_STREAM_LOAD_END,
  GET_BOOKING_CHANGES_LOAD_START,
  GET_BOOKING_CHANGES_LOAD_END,
  GET_FILTERED_BOOKINGS_LOAD_START,
  GET_FILTERED_BOOKINGS_LOAD_END,
  SEARCH_CHANGE,
  SET_USER_INFO,
  GET_COMPSETS_LOAD_START,
  GET_COMPSETS_LOAD_END,
  GET_COMPSET_LOAD_START,
  GET_COMPSET_LOAD_END,
  GET_COMPSET_LISTING_IDS_LOAD_START,
  GET_COMPSET_LISTING_IDS_LOAD_END,
  SET_IS_USER_ALLOWED,
  GET_USER_AIRBNB_LISTINGS_LOAD_START,
  GET_USER_AIRBNB_LISTINGS_LOAD_END,
  GET_LISTING_PRICING_RECOMMENDATION_LOAD_START,
  GET_LISTING_PRICING_RECOMMENDATION_LOAD_END,
  SET_CURRENCY,
  SET_SEARCH_LIMIT_BOX_ALERT,
  GET_BOOKING_DATA_LOAD_START,
  GET_BOOKING_DATA_LOAD_END,
  GET_BOOKING_MULTIPLE_MARKERS_LOAD_START,
  GET_BOOKING_MULTIPLE_MARKERS_LOAD_END,
  GET_NEARBY_RECOMMENDED_MARKETS_LOAD_START,
  GET_NEARBY_RECOMMENDED_MARKETS_LOAD_END,
  SET_REV_POTENTIAL_RANGE_INVESTMENT,
  SET_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN,
  EMPTY_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN,
  SET_BOUNDS_MAP_INSIGHTS,
  SET_FILTERS_INSIGHTS,
  SET_FILTER_INSIGHTS_ACTIVE,
  SET_USER_COUNTRY_CODE,
  SET_INDIVIDUAL_REV_POTENTIAL_RANGE,
  SET_HISTORICAL_DATA,
  SET_ANNUAL_REVENUE_DATA_FOR_CALCULATOR,
  GET_CACHED_SEARCH_MARKETS,
  SET_TOP_BANNER_OPEN,
  SET_MAX_SAMPLE_REV_POTENTIAL_PROPERTY_SIZE,
  SET_SEARCHED_MARKET_ESTIMATOR,
  GET_MARKET_CACHED_DATA,
  SET_MARKET_CACHED_DATA,
  SET_MARKET_DASHBOARD_FILTER_DATA,
  SET_PRICE_TIERS,
  UPDATE_PRICE_TIERS,
  GET_EXPLORER_MARKETS,
  SET_EXPLORER_MARKETS,
  GET_ADVANCED_MARKERS_LOAD_START,
  GET_ADVANCED_MULTIPLE_MARKERS_CALL_LOAD_END,
  GET_ADVANCED_MULTIPLE_MARKERS_CALL_LOAD_START,
  GET_ADVANCED_MARKERS_LOAD_END,
  GET_FUTURE_DAILY_DATA_LOAD_START,
  GET_FUTURE_DAILY_DATA_MULTIPLE_CALL_LOAD_END,
  GET_FUTURE_DAILY_DATA_MULTIPLE_CALL_LOAD_START,
  GET_FUTURE_DAILY_DATA_LOAD_END,
  SET_LOCKED_MARKET_DUMMY_DATA,
  SET_IS_CACHED_MARKET_DATA_SAMPLE,
  GET_MARKET_MONTHLY_PERFORMANCE_LOAD_START,
  GET_MARKET_MONTHLY_PERFORMANCE_LOAD_END,
  SET_LEAD_FORM_SOURCE,
  DEDUCT_ESTIMATOR_CREDIT,
  SET_USED_VERIFIED,
  SET_VISIBLE_LISTING_IDS,
  GET_VISIBLE_MAP_SUPPLY_LOAD_START,
  SET_VISIBLE_MAP_SUPPLY,
} from 'src/store/Dashboard/types';
import { convertBoundsArrayToObj } from 'src/utils/functions';

const initialState = {
  listings: {
    data: null,
    loading: true,
  },
  visibleMapSupply: {
    data: null,
    loading: true,
  },
  visibleListingIDs: [] as string[],
  filteredListingsDashboard: {
    loading: true,
    data: {
      propertyType: OVERVIEW_DASHBOARD_FILTER_DEMO_DATA.propertyType,
      propertySize: OVERVIEW_DASHBOARD_FILTER_DEMO_DATA.propertySize,
      bathroomNumber: OVERVIEW_DASHBOARD_FILTER_DEMO_DATA.bathroomNumber,
      adrRange: OVERVIEW_DASHBOARD_FILTER_DEMO_DATA.adrRange,
      ratingRange: OVERVIEW_DASHBOARD_FILTER_DEMO_DATA.ratingRange,
      minNightRange: OVERVIEW_DASHBOARD_FILTER_DEMO_DATA.minNightRange,
      listingsPerHost: OVERVIEW_DASHBOARD_FILTER_DEMO_DATA.listingsPerHost,
      // TODO: add demo data for distribution
      propertyTypeMetricsDistribution: {},
    },
  },
  otaListings: {
    data: null,
    loading: true,
  },
  multipleMarkersCallLoading: true,
  multipleOTAMarkersCallLoading: true,
  tailoredRegionMarkers: [],
  graph: {
    data: null,
    loading: true,
  },
  reviewStream: {
    data: null,
    loading: true,
  },
  search: {
    data: {
      name: '',
      city: '',
      country: '',
      lat: null,
      lng: null,
      polygon: '',
      countryCode: '',
      bounds: null,
      isVerified: false,
      marketID: null,
      cachedFilesCount: null,
      annualAppreciation: '',
      property_price: '',
      created_by: '',
      visibility: '',
      id: null,
      marketBlogLink: null,
    },
    loading: false,
  },
  user: {
    userName: 'Trial',
    email: 'Trial',
    regions: [],
    role: 'non-admin',
    userDescription: 'Trial',
    credits: 0,
    estimatorCredits: 0,
    userSignUpDay: '',
    isAirbnbLoggedIn: false,
    betaUser: true,
    isSubscribed: false,
    isVerified: false,
    hasAdditionalFreeMonthTrial: false,
    ab_test_pricing_group: '',
    estimatorRegions: [],
    nationwideAccess: [],
    blockListingExport: false,
    active_regions_metadata: [],
    workbooks: [],
    customerID: '',
    signupCountryCode: '',
    country_wide_access_list: [],
    isGlobalPlanUser: false,
    showDiscoveryAI: true,
    isAdvancePlanUser: false,
    subscriptionPlan: 'starter',
    loading: true,
  },
  bookingChanges: {
    data: null,
    loading: true,
  },
  filteredBookings: {
    data: null,
    loading: true,
  },
  compsets: {
    data: null,
    loading: true,
  },
  compset: {
    data: null,
    loading: true,
  },
  compsetListingIDs: {
    data: null,
    loading: true,
  },
  isUserAllowed: false,
  userAirbnbListings: {
    data: null,
    loading: true,
  },
  // listingPricingRecommendation: {
  //   data: null,
  //   loading: true,
  // },
  currency: 'USD',
  searchLimitAlertBox: false,
  bookingData: {
    loading: true,
    data: null,
  },
  multipleBookingMarkersCallLoading: true,
  nearbyRecommendedMarkets: {
    data: null,
    loading: true,
    notSupportedSearches: [],
  },
  revPotentialRangeInvestment: [],
  priceTiers: {
    Budget: {
      range: [],
      toggled: false,
    },
    Economy: {
      range: [],
      toggled: false,
    },
    Midscale: {
      range: [],
      toggled: false,
    },
    Upscale: {
      range: [],
      toggled: false,
    },
    Luxury: {
      range: [],
      toggled: false,
    },
  } as PriceTiers,
  googleAutocompleteSessionToken: null,
  googleAutocompleteSessionTokenTimeStamp: null,
  boundsMapInsights: null,
  filtersInsights: {
    roomType: ['all'],
    bedrooms: [100],
    bathrooms: [100],
    revenueFilter: ['all'],
    priceTierFilter: ['all'],
    accommodates: [1, 6],
    minimum_nights: [1, 30],
    number_of_reviews: 'all',
    rating: [3.9, 5],
    hostType: 'both',
    amenities: {
      pool: null,
      parking: null,
      hot_tub: null,
      gym: null,
      pets: null,
      dryer: null,
      washer: null,
      kitchen: null,
      ac: null,
      heating: null,
      wifi: null,
      tv: null,
      bbq_grill: null,
      fireplace: null,
      breakfast: null,
      beachfront: null,
      amazing_views: null,
    },
    showAllBookingComListings: false,
  } as FilterVal,
  userCountryCode: undefined,
  filterInsightsActive: false,
  historicalData: null,
  annualRevenueForCalculator: 0,
  cachedSearchMarkets: null,
  isTopBannerOpen: false,
  maxSampleRevPotentialPropertySize: 0,
  estimatorSearchMarket: '',
  cachedMarketData: {
    loading: true,
    data: null,
  },
  isCachedMarketDataSample: false,
  explorerMarkets: {
    loading: true,
    data: [],
  },
  advancedListings: {
    data: null,
    loading: false,
  },
  multipleAdvancedListingsCallLoading: true,
  listingsFutureData: {
    data: null,
    loading: true,
  },
  multipleListingsFutureDailyDataCallLoading: true,
  lockedMarketData: {
    data: null,
  },
  marketMonthlyPerformance: {
    data: null,
    loading: true,
  },
  leadFormSource: '',
};

export const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
    case GET_MARKERS_LOAD_START:
      return { ...state, listings: { ...state.listings, loading: true } };
    case GET_MARKERS_LOAD_END:
      return { ...state, listings: { data: action.payload, loading: false } };
    case GET_OTA_MARKERS_LOAD_START:
      return { ...state, otaListings: { ...state.otaListings, loading: true } };
    case GET_OTA_MARKERS_LOAD_END:
      return { ...state, otaListings: { data: action.payload, loading: false } };
    case GET_MULTIPLE_MARKERS_CALL_LOAD_START:
      return { ...state, multipleMarkersCallLoading: true };
    case GET_MULTIPLE_MARKERS_CALL_LOAD_END:
      return { ...state, multipleMarkersCallLoading: false };
    case GET_MULTIPLE_OTA_MARKERS_CALL_LOAD_START:
      return { ...state, multipleOTAMarkersCallLoading: true };
    case GET_MULTIPLE_OTA_MARKERS_CALL_LOAD_END:
      return { ...state, multipleOTAMarkersCallLoading: false };
    case GET_TAILORED_REGION_MARKERS_SUCCESS:
      return { ...state, tailoredRegionMarkers: action.payload };
    case GET_GRAPH_LOAD_START:
      return { ...state, graph: { ...state.graph, loading: true } };
    case GET_GRAPH_LOAD_END:
      return { ...state, graph: { data: action.payload, loading: false } };
    case GET_REVIEW_STREAM_LOAD_START:
      return { ...state, reviewStream: { ...state.reviewStream, loading: true } };
    case GET_REVIEW_STREAM_LOAD_END:
      return { ...state, reviewStream: { data: action.payload, loading: false } };
    case GET_BOOKING_CHANGES_LOAD_START:
      return { ...state, bookingChanges: { ...state.bookingChanges, loading: true } };
    case GET_BOOKING_CHANGES_LOAD_END:
      return { ...state, bookingChanges: { data: action.payload, loading: false } };
    case GET_FILTERED_BOOKINGS_LOAD_START:
      return { ...state, filteredBookings: { ...state.filteredBookings, loading: true } };
    case GET_FILTERED_BOOKINGS_LOAD_END:
      return { ...state, filteredBookings: { data: action.payload, loading: false } };
    case GET_SEARCH_LOAD_START:
      return { ...state, search: { ...state.search, loading: true } };
    case GET_SEARCH_LOAD_END:
      return { ...state, search: { ...state.search, loading: false } };
    case SEARCH_CHANGE:
      return { ...state, search: { ...state.search, ...action.payload } };
    case SET_USER_INFO:
      return { ...state, user: { ...action.payload } };
    case GET_COMPSETS_LOAD_START:
      return { ...state, compsets: { ...state.compsets, loading: true } };
    case GET_COMPSETS_LOAD_END:
      return { ...state, compsets: { data: action.payload, loading: false } };
    case GET_COMPSET_LOAD_START:
      return { ...state, compset: { ...state.compset, loading: true } };
    case GET_COMPSET_LOAD_END:
      return { ...state, compset: { data: action.payload, loading: false } };
    case GET_COMPSET_LISTING_IDS_LOAD_START:
      return { ...state, compsetListingIDs: { ...state.compsetListingIDs, loading: true } };
    case GET_COMPSET_LISTING_IDS_LOAD_END:
      return { ...state, compsetListingIDs: { data: action.payload, loading: false } };
    case SET_IS_USER_ALLOWED:
      return { ...state, isUserAllowed: action.payload };
    case GET_USER_AIRBNB_LISTINGS_LOAD_START:
      return { ...state, userAirbnbListings: { ...state.userAirbnbListings, loading: true } };
    case GET_USER_AIRBNB_LISTINGS_LOAD_END:
      return { ...state, userAirbnbListings: { data: action.payload, loading: false } };
    // case GET_LISTING_PRICING_RECOMMENDATION_LOAD_START:
    //   return {
    //     ...state,
    //     listingPricingRecommendation: { ...state.listingPricingRecommendation, loading: true },
    //   };
    // case GET_LISTING_PRICING_RECOMMENDATION_LOAD_END:
    //   return { ...state, listingPricingRecommendation: { data: action.payload, loading: false } };
    case SET_CURRENCY:
      return { ...state, currency: action.payload };
    case SET_SEARCH_LIMIT_BOX_ALERT:
      return { ...state, searchLimitAlertBox: action.payload };
    case GET_BOOKING_DATA_LOAD_START:
      return { ...state, bookingData: { loading: true } };
    case GET_BOOKING_DATA_LOAD_END:
      return { ...state, bookingData: { loading: false, data: action.payload } };
    case GET_BOOKING_MULTIPLE_MARKERS_LOAD_START:
      return { ...state, multipleBookingMarkersCallLoading: true };
    case GET_BOOKING_MULTIPLE_MARKERS_LOAD_END:
      return { ...state, multipleBookingMarkersCallLoading: false };
    case GET_NEARBY_RECOMMENDED_MARKETS_LOAD_START:
      return {
        ...state,
        nearbyRecommendedMarkets: { ...state.nearbyRecommendedMarkets, loading: true },
      };
    case GET_NEARBY_RECOMMENDED_MARKETS_LOAD_END:
      return {
        ...state,
        nearbyRecommendedMarkets: {
          data: action.payload.message,
          loading: false,
          notSupportedSearches: action.payload.notSupportedInputs,
        },
      };
    case SET_REV_POTENTIAL_RANGE_INVESTMENT:
      const revenueRangeObj = {};
      for (let revenue of action.payload) {
        revenueRangeObj[revenue] = 'visible';
      }
      return { ...state, revPotentialRangeInvestment: revenueRangeObj };
    case SET_INDIVIDUAL_REV_POTENTIAL_RANGE:
      return { ...state, revPotentialRangeInvestment: action.payload };
    case SET_PRICE_TIERS:
      const adrLTMRange = action.payload;
      const priceTiers = {
        Budget: {
          range: [0, adrLTMRange[0]],
          toggled: false,
        },
        Economy: {
          range: [adrLTMRange[0], adrLTMRange[1]],
          toggled: false,
        },
        Midscale: {
          range: [adrLTMRange[1], adrLTMRange[2]],
          toggled: false,
        },
        Upscale: {
          range: [adrLTMRange[2], adrLTMRange[3]],
          toggled: false,
        },
        Luxury: {
          range: [adrLTMRange[3], 999999],
          toggled: false,
        },
      };
      return { ...state, priceTiers: priceTiers };
    case UPDATE_PRICE_TIERS:
      return { ...state, priceTiers: action.payload };
    case SET_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN:
      return {
        ...state,
        googleAutocompleteSessionToken: action.payload,
        googleAutocompleteSessionTokenTimeStamp: Date.now(),
      };
    case EMPTY_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN:
      return {
        ...state,
        googleAutocompleteSessionToken: null,
        googleAutocompleteSessionTokenTimeStamp: null,
      };
    case SET_BOUNDS_MAP_INSIGHTS:
      return { ...state, boundsMapInsights: action.payload };
    case SET_FILTERS_INSIGHTS:
      return { ...state, filtersInsights: action.payload };
    case SET_FILTER_INSIGHTS_ACTIVE:
      return { ...state, filterInsightsActive: action.payload };
    case SET_USER_COUNTRY_CODE:
      return { ...state, userCountryCode: action.payload };
    case SET_HISTORICAL_DATA:
      return { ...state, historicalData: action.payload };
    case SET_ANNUAL_REVENUE_DATA_FOR_CALCULATOR:
      return { ...state, annualRevenueForCalculator: action.payload };
    case GET_CACHED_SEARCH_MARKETS:
      return { ...state, cachedSearchMarkets: action.payload };
    case SET_TOP_BANNER_OPEN:
      return { ...state, isTopBannerOpen: action.payload };
    case SET_MAX_SAMPLE_REV_POTENTIAL_PROPERTY_SIZE:
      return { ...state, maxSampleRevPotentialPropertySize: action.payload };
    case SET_SEARCHED_MARKET_ESTIMATOR:
      return { ...state, estimatorSearchMarket: action.payload };
    case GET_MARKET_CACHED_DATA:
      return { ...state, cachedMarketData: { loading: true, data: null } };
    case SET_MARKET_CACHED_DATA:
      return { ...state, cachedMarketData: { loading: false, data: action.payload } };
    case SET_IS_CACHED_MARKET_DATA_SAMPLE:
      return { ...state, isCachedMarketDataSample: action.payload };
    case SET_MARKET_DASHBOARD_FILTER_DATA:
      return { ...state, filteredListingsDashboard: { loading: false, data: action.payload } };
    case GET_EXPLORER_MARKETS:
      return { ...state, explorerMarkets: { ...state.explorerMarkets, loading: true } };
    case SET_EXPLORER_MARKETS:
      return { ...state, explorerMarkets: { data: action.payload, loading: false } };

    case GET_ADVANCED_MARKERS_LOAD_START:
      return {
        ...state,
        advancedListings: { ...state.advancedListings, loading: true },
      };
    case GET_ADVANCED_MARKERS_LOAD_END:
      return { ...state, advancedListings: { data: action.payload, loading: false } };
    case GET_ADVANCED_MULTIPLE_MARKERS_CALL_LOAD_START:
      return { ...state, multipleAdvancedListingsCallLoading: true };
    case GET_ADVANCED_MULTIPLE_MARKERS_CALL_LOAD_END:
      return { ...state, multipleAdvancedListingsCallLoading: false };
    case GET_FUTURE_DAILY_DATA_LOAD_START:
      return {
        ...state,
        listingsFutureData: { ...state.listingsFutureData, loading: true },
      };
    case GET_FUTURE_DAILY_DATA_LOAD_END:
      return { ...state, listingsFutureData: { data: action.payload, loading: false } };
    case GET_FUTURE_DAILY_DATA_MULTIPLE_CALL_LOAD_END:
      return { ...state, multipleListingsFutureDailyDataCallLoading: true };
    case GET_FUTURE_DAILY_DATA_MULTIPLE_CALL_LOAD_START:
      return { ...state, multipleListingsFutureDailyDataCallLoading: false };
    case SET_LOCKED_MARKET_DUMMY_DATA:
      return { ...state, lockedMarketData: { data: action.payload } };
    case GET_MARKET_MONTHLY_PERFORMANCE_LOAD_START:
      return {
        ...state,
        marketMonthlyPerformance: { ...state.marketMonthlyPerformance, loading: true },
      };
    case GET_MARKET_MONTHLY_PERFORMANCE_LOAD_END:
      return { ...state, marketMonthlyPerformance: { data: action.payload, loading: false } };
    case SET_LEAD_FORM_SOURCE:
      return { ...state, leadFormSource: action.payload };
    case DEDUCT_ESTIMATOR_CREDIT:
      return {
        ...state,
        user: { ...state.user, estimatorCredits: state.user.estimatorCredits - 1 },
      };
    case SET_USED_VERIFIED:
      return { ...state, user: { ...state.user, isVerified: true } };
    case SET_VISIBLE_LISTING_IDS:
      return { ...state, visibleListingIDs: action.payload };
    case GET_VISIBLE_MAP_SUPPLY_LOAD_START:
      return { ...state, visibleMapSupply: { ...state.visibleMapSupply, loading: true } };
    case SET_VISIBLE_MAP_SUPPLY:
      return { ...state, visibleMapSupply: { data: action.payload, loading: false } };
  }
};
